/**
 * 镜头缩放：手机上双指捏合（Pinch）、电脑滚轮、键盘 + / - / 0 复位。
 * 缩放时保持画面中心不动，边界由相机自己 _clamp 处理。
 */
const MIN_ZOOM = 0.7;
const MAX_ZOOM = 2.6;

const clampZoom = (z) => Math.max(MIN_ZOOM, Math.min(MAX_ZOOM, z));
const touchDist = (touches) => Math.hypot(
  touches[0].clientX - touches[1].clientX,
  touches[0].clientY - touches[1].clientY,
);

export function installCameraZoom(engine, el) {
  const cam = engine.camera;

  /** 围绕画面中心缩放，视野中心不跑偏 */
  function setZoom(z, centerScreen) {
    const vw = cam.viewW, vh = cam.viewH;
    const c = centerScreen || { x: vw / 2, y: vh / 2 };
    const before = cam.screenToWorld(c.x, c.y);
    cam.zoom = clampZoom(z);
    cam.x = before.x - c.x / cam.zoom;
    cam.y = before.y - c.y / cam.zoom;
    cam._clamp();
  }

  // 电脑滚轮
  el.addEventListener('wheel', (e) => {
    if (e.ctrlKey) return;               // 交给浏览器
    e.preventDefault();
    setZoom(cam.zoom * (e.deltaY < 0 ? 1.12 : 1 / 1.12));
  }, { passive: false });

  // 手机双指捏合
  let pinch = null;
  el.addEventListener('touchstart', (e) => {
    if (e.touches.length === 2) {
      pinch = { d0: touchDist(e.touches), z0: cam.zoom };
    }
  }, { passive: true });

  el.addEventListener('touchmove', (e) => {
    if (e.touches.length !== 2 || !pinch) return;
    e.preventDefault();
    setZoom(pinch.z0 * (touchDist(e.touches) / pinch.d0));
  }, { passive: false });

  const endPinch = (e) => { if (!e.touches || e.touches.length < 2) pinch = null; };
  el.addEventListener('touchend', endPinch, { passive: true });
  el.addEventListener('touchcancel', endPinch, { passive: true });

  // 键盘：+ / - / 0
  window.addEventListener('keydown', (e) => {
    const tag = e.target && e.target.tagName;
    if (tag === 'INPUT' || tag === 'TEXTAREA') return;
    if (e.key === '+' || e.key === '=') { setZoom(cam.zoom * 1.15); e.preventDefault(); }
    else if (e.key === '-' || e.key === '_') { setZoom(cam.zoom / 1.15); e.preventDefault(); }
    else if (e.key === '0') { setZoom(1); e.preventDefault(); }
  });

  return { setZoom, MIN_ZOOM, MAX_ZOOM };
}
